import React, { useEffect, useState } from 'react';
import Page from '../../../components/Page/Page';
import { socket } from '../../../socketio/socketio';
import { useTypedSelector } from '../../../redux/hooks';
import { IonCard } from '@ionic/react';

export const SocketTestPage: React.FC = () => {
  const [counter, setCounter] = useState(0);

  const token = useTypedSelector(s => s.auth._token);

  useEffect(() => {
    if (!token) return;

    socket.on('socket_test__server_emit', (data, acknowledgeCallback) => {
      setCounter(data.counter);
      acknowledgeCallback('OKAY'); // this trigger ack() function on BACKEND
    });

    return () => {
      socket.off('socket_test__server_emit');
    };
  }, [token]);

  return (
    <Page headerProps={{ title: 'Messages' }}>
      <IonCard
        style={{ margin: '10px' }}
        onClick={() => socket.emit('socket_test__client_emit', { counter })}
      >
        <p>No new messages {counter || ''}</p>
      </IonCard>
    </Page>
  );
};

export default SocketTestPage;
